// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as Core$1 from "@react-pdf-viewer/core";
import * as App_Modal$DvmAdminFrontendFr from "../../../../../../common/components/App_Modal.bs.js";
import * as App_Spinner$DvmAdminFrontendFr from "../../../../../../common/components/App_Spinner.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../../context/user/User_Context.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../../../../common/components/App_LabeledText.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../../common/types/App_Types_Result.bs.js";
import * as Messages_ModelVersion$DvmAdminFrontendFr from "../../../../../../intl/messages/modelVersion/Messages_ModelVersion.bs.js";
import * as Messages_Orders_DealerRequest$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_DealerRequest.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Documents_Api$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Documents_Api.bs.js";

function Order_Detail_Bonus_DealerRequest_Documents_PdfView(Props) {
  var onClose = Props.onClose;
  var item = Props.item;
  var fileType = Props.fileType;
  var alert = ReactAlert.useAlert();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        
      });
  var setPdfArray = match$2[1];
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDownloadResult = match$3[1];
  var downloadResult = match$3[0];
  React.useEffect((function () {
          Belt_Option.mapWithDefault(item.fileId, undefined, (function (x) {
                  Order_Detail_Bonus_DealerRequest_Documents_Api$DvmAdminFrontendFr.getPdf(userManager, setDownloadResult, x, alert, selectedRole);
                }));
        }), []);
  var blobToByteArray = async function (x) {
    var buffer = await x.arrayBuffer();
    return Curry._1(setPdfArray, (function (param) {
                  return Caml_option.some(new Uint8Array(buffer));
                }));
  };
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(downloadResult, undefined, (function (x) {
                  blobToByteArray(x);
                }));
        }), [downloadResult]);
  return React.createElement(App_Modal$DvmAdminFrontendFr.make, {
              open: true,
              onClose: onClose,
              title: "",
              minWidth: "1000px",
              children: null,
              padding: "0px 0px 36px 0px"
            }, React.createElement(Core.AppBar, {
                  elevation: 1,
                  children: React.createElement(Core.Grid, {
                        children: null,
                        container: true,
                        justifyContent: "space-between"
                      }, React.createElement(Core.Grid, {
                            children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                  label: Messages_Orders_DealerRequest$DvmAdminFrontendFr.documentName,
                                  children: Belt_Option.getWithDefault(item.fileName, "-")
                                }),
                            item: true
                          }), React.createElement(Core.Grid, {
                            children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                  label: Messages_ModelVersion$DvmAdminFrontendFr._type,
                                  children: fileType
                                }),
                            item: true
                          }), React.createElement(Core.Grid, {
                            children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                  label: Messages_Common$DvmAdminFrontendFr.comment,
                                  children: Belt_Option.getWithDefault(item.comment, "-")
                                }),
                            item: true
                          })),
                  position: "sticky",
                  style: {
                    backgroundColor: "white",
                    color: "black",
                    marginBottom: "20px",
                    padding: "20px"
                  }
                }), App_Types_Result$DvmAdminFrontendFr.isPending(downloadResult) ? React.createElement(App_Spinner$DvmAdminFrontendFr.make, {}) : Belt_Option.mapWithDefault(match$2[0], null, (function (x) {
                      return React.createElement(Core$1.Worker, {
                                  workerUrl: "https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js",
                                  children: React.createElement(Core$1.Viewer, {
                                        fileUrl: x
                                      })
                                });
                    })));
}

var Api;

var Types;

var make = Order_Detail_Bonus_DealerRequest_Documents_PdfView;

export {
  Api ,
  Types ,
  make ,
}
/* react Not a pure module */
